import React, { useMemo } from 'react';

const computeDiff = (original = '', revised = '') => {
  if (original === revised) {
    return [{ type: 'unchanged', text: original }];
  }
  const chunks = [];
  if (original) {
    chunks.push({ type: 'removed', text: original });
  }
  if (revised) {
    chunks.push({ type: 'added', text: revised });
  }
  return chunks;
};

export function AIIslandDiff({
  original,
  revised,
  onAcceptAll,
  onAcceptChunk,
  titleLabel,
  acceptAllLabel,
}) {
  const diffChunks = useMemo(() => computeDiff(original, revised), [original, revised]);

  return (
    <div className="ai-island-diff">
      <div className="ai-island-diff__header">
        <span>{titleLabel || 'Suggested changes'}</span>
        <button type="button" onClick={onAcceptAll}>
          {acceptAllLabel || 'Accept all'}
        </button>
      </div>
      <div className="ai-island-diff__content">
        {diffChunks.map((chunk, index) => (
          <span
            key={`${chunk.type}-${index}`}
            className={`ai-island-diff__chunk ai-island-diff__chunk--${chunk.type}`}
            onClick={() => chunk.type !== 'unchanged' && onAcceptChunk(index)}
            role={chunk.type !== 'unchanged' ? 'button' : undefined}
            tabIndex={chunk.type !== 'unchanged' ? 0 : -1}
          >
            {chunk.text}
          </span>
        ))}
      </div>
    </div>
  );
}
